import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export const TooltipCss = ({ children, className, title, position, as, ...rest }) => {
  const Tag = as ? as : "div";

  return (
    <Tag
      className={classNames(
        "c-cooltip",
        {
          "c-cooltip--top": position === "top",
          "c-cooltip--right": position === "right",
          "c-cooltip--bottom": position === "bottom",
          "c-cooltip--left": position === "left",
        },
        className
      )}
      {...rest}
      data-tooltip={title}
    >
      {children}
    </Tag>
  );
};

TooltipCss.propTypes = {
  className: PropTypes.string,
  as: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  position: PropTypes.oneOf(["top", "right", "bottom", "left"]),
};

TooltipCss.defaultProps = {
  position: "top",
  as: "div",
};
